import { Card, CardContent, CardHeader, Divider } from "@mui/material";
import { useOutletContext } from "react-router-dom";
import KpiInformationForm from "./KpiInformationForm";

export default function KpiSettingGeneral() {
    const { kpi } = useOutletContext();

    return (
        <Card variant="outlined">
            <CardHeader title="General"></CardHeader>
            <Divider variant="middle" />
            <CardContent>
                <KpiInformationForm kpi={kpi} />
            </CardContent>
        </Card>
    );
}
